import type { ComboboxOption } from '@opendoor/atoms/combobox';
import type { MarketplaceZoneType } from 'components/marketplace/map/__generated__/location-search.zeus';

import type { RangeOption } from './types';

export const buildRangeFilterOptions = (
  options: readonly RangeOption[],
  placeholderOption: RangeOption,
): ComboboxOption[] =>
  options.some((option) => option.value === placeholderOption.value)
    ? options.slice()
    : [placeholderOption, ...options];

export const filterIntOptions = (
  options: readonly RangeOption[],
  op: 'gt' | 'lt',
  limit?: string,
): RangeOption[] => {
  if (!limit) {
    return options.slice();
  }

  const limitVal = parseInt(limit, 10);
  if (isNaN(limitVal)) {
    return options.slice();
  }

  return options.filter((option) => {
    const val = parseInt(option.value, 10);
    if (op === 'gt') {
      return val > limitVal;
    }

    return val < limitVal;
  });
};

enum MapSearchZoom {
  CITY = 9,
  ZIP = 11,
  NEIGHBORHOOD = 13,
}

const mapSearchZoom = {
  CITY: MapSearchZoom.CITY,
  COUNTY: MapSearchZoom.CITY,
  MACRO_NEIGHBORHOOD: MapSearchZoom.NEIGHBORHOOD,
  NEIGHBORHOOD: MapSearchZoom.NEIGHBORHOOD,
  RESIDENTIAL_BOUNDARY: MapSearchZoom.CITY,
  STATE: MapSearchZoom.CITY,
  SUBNEIGHBORHOOD: MapSearchZoom.NEIGHBORHOOD,
  UNKNOWN: MapSearchZoom.CITY,
  ZIP_CODE: MapSearchZoom.ZIP,
} satisfies Record<MarketplaceZoneType, MapSearchZoom>;

// Based on API limits
export const MAX_MARKETS = 150;

// Fallback market when none specified or invalid
export const DEFAULT_MARKET = 'phoenix';

export const getZoomForLocationType = (zoneType: MarketplaceZoneType = 'CITY'): number =>
  mapSearchZoom[zoneType];
